import { defineMessage } from 'react-intl';
export const unavailableComputerModelMessage = defineMessage({
    defaultMessage: '{model} unavailable',
    description: 'Composer label for a saved custom Computer model absent from the available model catalog',
    id: 'b658657188',
});
//# sourceMappingURL=ComputerModelAvailabilityMessages.js.map